var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('h3',[_vm._v(" "+_vm._s(_vm.item.name)+" "),_c('ItemAdminLinks',{attrs:{"item":_vm.item}})],1),_c('p',{ref:"text",domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }